// extracted by mini-css-extract-plugin
export default {"history":"style_history__vmq8c","table_container":"style_table_container__zu2Bt","historyImage":"style_historyImage__JdZOF","required":"style_required__t4IrH"};